import React from 'react';
import SectionHeader from '../../ui/SectionHeader';

import RestClient from '../../rest/RestClient';

//https://momentjs.com/
import moment from 'moment';
import MicroEvent  from '../../other/microevent';
import CommonHelper from '../../helpers/CommonHelper';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import {confirmAlert} from "react-confirm-alert";

export default class PanelLog extends React.Component {

  id_waitForObtain = null;
  lineTimer = null

  constructor(props) {
    super(props);

    MicroEvent.mixin(PanelLog);
    this.bind('refreshLog');

    this.state = {
       events : [],
       initialEvCount: 0,
    };

    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    this.id_waitForObtain = setInterval(() =>
    {
      if(RestClient.allowedNonEnterQueries()){
        clearInterval(this.id_waitForObtain);

        this.loadData();
        var refId = setInterval(this.loadData, 5*1000);
        this.setState({refInterval_forRefreshLog:refId});
      }
    }, 50); // n milliseconds
  }

  componentWillUnmount(){
    var id = (this.state.refInterval_forRefreshLog);

    if(!CommonHelper.isNull(id)){
      clearInterval(id);
    }
    if(this.lineTimer != null)
      clearInterval(this.lineTimer)
  }

  refreshLog(){
    this.loadData();
  }

  loadData() {
    RestClient.getEvents(
      (list)=>{
        list = list.filter(line => (line.message.indexOf('The index does not exist in the cursor') == -1))
        
        if(this.state.events.length == 0){
          this.state.initialEvCount = list.length;
        }
        this.state.events = list
        this.setState(this.state);

        if ( this.state.events.length > this.state.initialEvCount && !this.lineTimer ) {
          this.lineTimer = setInterval(this.printEachNewEvent, 5000)
        }

      },
      ()=>{
        //console.log('zerror accountInfo');
      }
    );
  }

  printEachNewEvent = () => {
    const {
      events,
      initialEvCount,
    } = this.state


    if ( events.length == initialEvCount && this.lineTimer) {
      clearInterval(this.lineTimer)
      this.lineTimer = null
    }
    else {
      this.setState({ initialEvCount: this.state.initialEvCount + 1 })
    }

  }

  printEvents() {
    const { initialEvCount, events } = this.state
    var txt = '';
    var cnt = this.state.events.length;

    if (cnt === 0)
    {
        // Якщо ти читаєш це повідомлення знай мене вже не має я став програмістом і став частиною кода, щоб не відбувався видалення цього повідомлення
      txt = 'There is no messages for now...';

    }

    const evForDisplay = (events.length > initialEvCount) ? events.slice(events.length - initialEvCount) : events

      var time_start_showed=false;
    for (let i in evForDisplay)
    {
      var event = evForDisplay[i];
      var t = moment.unix(Number(event['timestamp']));

      var time_start = moment.unix(Number(event['start'])).format("YYYY-MM-DD HH:mm:ss");


      var line = t.format("YYYY-MM-DD HH:mm:ss  ")
            + CommonHelper.uppercaseFirstLetter(event['title'])
            + ((CommonHelper.isEmpty(event['message']))?' ':(' '+event['message']))
            + (((!time_start_showed)&&("successfully scheduled." == event['message']))?(' It starts at: ' + time_start):' ')
            + '\r\n' ;
      if("successfully scheduled." == event['message']) time_start_showed=true;

      txt+= (event['id'] == 'waiting') ? `<div class="waiting" style="display: inline-flex;"><div style="margin-top: 15px;">${line}</div> <img style="width: 80px;" src="https://staging.soundcloudhelper.com/loader.gif"></div><br />` : line;
    }

    return {__html: txt};
  }


  render() {
    return (
        <div className="panel-log component-bottom-margin">
          <Container>
            <Row className='mb-4'>
              <Col>
                <h1>Log</h1>
              </Col>
            </Row>
            <Row>
              <Col>
              <div className="logbox" >
                <div className="logbox-content"><pre dangerouslySetInnerHTML={this.printEvents()} /></div>
              </div>
              </Col>
            </Row>
          </Container>
        </div>
    )
  }
}
